import { createContext, useContext } from "react";
import type { AppHistory } from "./appHistory";

export const NavigationContext = createContext<AppHistory | null>(null);

export function useNavigationIdentity() {
  const history = useContext(NavigationContext);
  if (!history) throw new Error("Navigation must be used inside AppRouter.");
  return history.setIdentity;
}
